<li class="m-tree-node"
    :class="{ 'm--is-selected': isSelected && !isDisabled,
            'm--is-disabled' : isDisabled,
            'm--is-read-only' : isReadonlyStyle,
            'm--has-children' : isFolder,
            'm--is-with-checkboxes' : withCheckboxes,
            'm--has-file-icons' : useFilesIcons }">
    <div class="m-tree-node__item"
         :class="{ 'm--no-hover': moveSelectionZoneToCheckbox }"
         ref="item"
         :tabindex="isDisabled || (withCheckboxes && !isFolder) ? '-1' : 0"
         role="button"
         :aria-selected="isSelected && !isDisabled"
         @click="onClick"
         @keypress.enter="onClick"
         @keypress.space.prevent="onClick">
        <m-tree-icon v-if="useFilesIcons"
                     :is-folder-open="internalOpen"
                     :is-folder="isFolder"></m-tree-icon>
        <m-tree-icon :filename="node.id"
                     :is-folder-open="internalOpen"
                     :use-files-icons="useFilesIcons"
                     :is-folder="isFolder"></m-tree-icon>
        <m-checkbox v-if="withCheckboxes"
                    class="m-tree-node__checkbox"
                    ref="checkbox"
                    :value="isSelected"
                    :indeterminate="isIndeterminate"
                    :disabled="isDisabled"
                    :readonly="readonly"
                    @change="onCheckboxClick">{{label}}</m-checkbox>
        <template v-if="!withCheckboxes">
            <span class="m-tree-node__item-label">{{label}}</span>
            <span v-if="!isFolder"
                  class="m-tree-node__item-check"
                  aria-hidden="true"></span>
        </template>
        <m-icon v-if="hasRightIcon"
                class="m-tree-node__warning-icon"
                :name="node.rightIconName"
                size="1em"></m-icon>
    </div>
    <template v-if="isFolder">
        <m-accordion-transition v-if="hasChildren">
            <ul class="m-tree-node__children"
                :class="{'m--has-line-extension' : hasSibling}"
                ref="children"
                v-show="internalOpen"
                role="tabpanel">
                <m-tree-node v-for="(childNode, index) in node.children"
                             :key="childNode.id"
                             class="m-tree-node__child"
                             :path="currentPath"
                             :selectable="selectable"
                             :selected="isSelected"
                             :readonly="readonly"
                             :open.sync="childNode.open"
                             :node="childNode"
                             :use-files-icons="useFilesIcons"
                             :selected-nodes="selectedNodes"
                             :disabled-nodes="disabledNodes"
                             :checkboxes="checkboxes"
                             :has-sibling="childHasSibling(index)"
                             @auto-select-child-checkbox-change="onAutoSelectChildCheckboxChange"
                             @click="emitClick"></m-tree-node>
            </ul>
        </m-accordion-transition>
        <m-accordion-transition v-else>
            <ul v-show="internalOpen"
                class="m-tree-node__children"
                :class="{'m--has-line-extension' : hasSibling}"
                role="tabpanel">
                <li class="m-tree-node__child-empty">
                    {{emptyContentMessage}}
                </li>
            </ul>
        </m-accordion-transition>
    </template>
    <template v-if="displaySelectionButton">
        <button class="m-tree-node__auto-select-button"
                :class="{ 'm--is-selected': allChildrenAndSelfSelected}"
                @click="onAutoSelectButtonClick"
                ref="autoSelectButton"></button>
    </template>
</li>
